import {bootstrapApplication} from '@angular/platform-browser';
import {defineCustomElements} from '@ionic/pwa-elements/loader';
import {appConfig} from 'src/app/app.config';
import {AppComponent} from 'src/app/app.component';
import * as Sentry from "@sentry/angular";
import {environment} from 'src/app/environments/environment';

Sentry.init({
  dsn: "https://6a1bd186e5457284c6cff9fba4177c72@o4510578813763584.ingest.de.sentry.io/4510579009847376",
  environment: environment.production ? 'production' : 'development'
});

defineCustomElements(window);

bootstrapApplication(AppComponent, appConfig)
  .catch(error => console.error(error));
